export const Terms = {
  version: 1,
  url: "https://transfrinc.com/terms/",
};

export const PrivacyPolicy = {
  url: "https://transfrinc.com/privacy/",
};

export const TrekFeedbackForm = {
  url: "http://bit.ly/trekfeedback",
};

export const TransfrFeedbackForm = {
  url: "https://transfr.qualtrics.com/jfe/form/SV_0k8McRqkP7cqzlk",
  getUrl: function ({ orgCode, email }) {
    const url = new URL(this.url);

    if (orgCode) {
      url.searchParams.set("clientcode", orgCode);
    }

    if (email) {
      url.searchParams.set("clientemail", email);
    }

    return url.toString();
  },
};

export const SupportCenterForm = {
  url: "https://support.transfrinc.com/",
};
